import React from 'react';
import { Row } from "react-flexbox-grid";
import Form from 'react-bootstrap/Form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import './styles.css'

const Errors = ({error, onCloseBox}) =>
    <Form.Group as={Row} style={{padding: '5px'}} controlId="ipslocationsHeading">
        {error &&
        <Form.Label className='error-style' column sm={12}>
            {error ? error : ''}
            <FontAwesomeIcon className='close-button' onClick={onCloseBox} icon={faTimes} />
        </Form.Label>
        }
    </Form.Group>;

export default Errors;